
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta } from "/src/pages/index.vue?macro=true";
import { default as index4P_Gc98vStKwJkbGy7e9Z3NNmG0F_BlCdz1J2my43OUMeta } from "/src/pages/contact/index.vue?macro=true";
import { default as index4vg97pzD1iqokuMDg_Spdas2N_45BQI_H2v7U1f3NMxMYMeta } from "/src/pages/websites/index.vue?macro=true";
import { default as indexOAb4nvZO2nXFlZrHtOWzfPKclU0WeX_45oJeLWM1u8xBAMeta } from "/src/pages/expertise/index.vue?macro=true";
import { default as index_6Ee1Hb7QM46JWNaSTe8mNA0cTDBZ7UnofL7nqlxKuwMeta } from "/src/pages/landing-page/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/src/pages/contact/index.vue")
  },
  {
    name: "websites",
    path: "/websites",
    component: () => import("/src/pages/websites/index.vue")
  },
  {
    name: "expertise",
    path: "/expertise",
    component: () => import("/src/pages/expertise/index.vue")
  },
  {
    name: "landing-page",
    path: "/landing-page",
    component: () => import("/src/pages/landing-page/index.vue")
  }
]